import { useSessionStorageState } from "ahooks"
import { Step, Steps, Visit } from "interface/visit"

export function useStepCompletion(visit: Visit) {
	const [state, setState] = useSessionStorageState<Steps>(`steps-${visit.id}`, {
		listenStorageChange: true,
	})

	return {
		...state,
		isFullyComplete: (...steps: Step[]) =>
			state &&
			Object.entries(state).length === steps.length &&
			steps.every((step) => !!state[step]),
		markStepAs: (step: Step, complete: boolean = true) =>
			setState((prev) => ({ ...prev, [step]: complete })),
	}
}
